module.exports = __webpack_public_path__ + "static/media/submitted-bid-icon.f274271a.svg";